import { render, staticRenderFns } from "./AgencyProfile.vue?vue&type=template&id=22c65db8&scoped=true&"
import script from "./AgencyProfile.vue?vue&type=script&lang=js&"
export * from "./AgencyProfile.vue?vue&type=script&lang=js&"
import style0 from "./AgencyProfile.vue?vue&type=style&index=0&id=22c65db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c65db8",
  null
  
)

export default component.exports